import { useState } from 'react'
import { User } from 'lucide-react'
import { getSpeakerImageClasses, getSpeakerObjectPosition, resolveSpeakerPhoto } from '../../utils/imageUrl'

export default function SpeakerImage({
  speaker,
  alt,
  className = '',
  fallbackClassName = '',
  fit = 'card',
  style,
  ...props
}) {
  const [src, setSrc] = useState(() => resolveSpeakerPhoto(speaker))
  const objectPosition = getSpeakerObjectPosition(speaker?.name, fit)
  const fitClasses = getSpeakerImageClasses(fit)

  if (!src) {
    return (
      <div className={`bg-cinema-charcoal flex flex-col items-center justify-center gap-2 ${fallbackClassName || className}`}>
        <User className="w-1/4 h-1/4 max-w-12 max-h-12 text-cinema-muted/40" />
        <span className="text-cinema-muted/60 text-xs font-sans text-center px-2">{alt || speaker?.name}</span>
      </div>
    )
  }

  const handleError = () => {
    if (src.startsWith('http') && src.includes('/Speakers/')) {
      const filename = src.split('/Speakers/').pop()
      const publicPath = `/Speakers/${filename}`
      if (publicPath !== src) {
        setSrc(publicPath)
        return
      }
    }
    setSrc(null)
  }

  return (
    <img
      src={src}
      alt={alt || speaker?.name || 'Speaker'}
      className={`${fitClasses} ${className}`.trim()}
      style={{ objectPosition, ...style }}
      onError={handleError}
      {...props}
    />
  )
}
